import type { Client } from '@efdigital/ll-addon-data';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import { Tags } from '../tags.gts';

function not(value: unknown) {
  return !value;
}

interface Signature {
  Args: {
    client: Client;
    uniqueId: string;
    isReadOnly: boolean;
  };
}

class UsersSection extends Component<Signature> {
  @tracked newConnection = '';
  @tracked newDomain = '';

  get isReadOnly() {
    return this.args.isReadOnly;
  }

  setDomains = (domains: string[]) => {
    this.args.client.domains = domains;
  };

  setConnections = (connections: string[]) => {
    this.args.client.connections = connections;
  };

  setBlockMailouts = (event: Event) => {
    const target = event.target as HTMLInputElement;
    this.args.client.blockMailouts = not(target.checked);
  };

  <template>
    <fieldset class="mb-4" disabled={{this.isReadOnly}}>
      <legend class="gud-eyebrow">Communications</legend>
      <div class="mb-3">
        <div class="form-check">
          <input
            id="{{@uniqueId}}-enableMailouts"
            name="blockMailouts"
            type="checkbox"
            class="form-check-input"
            checked={{not @client.blockMailouts}}
            {{on "change" this.setBlockMailouts}}
          />
          <label for="{{@uniqueId}}-enableMailouts" class="form-check-label">
            Allow promotional e-mails (e.g. newsletters, updates) to be sent to
            users associated with this client.
          </label>
        </div>
      </div>
    </fieldset>

    <fieldset class="mb-4" disabled={{this.isReadOnly}}>
      <legend class="gud-eyebrow">User Registration</legend>

      <div class="mb-3">
        <label class="form-label">Single Sign On</label>
        <Tags
          @tags={{@client.connections}}
          @readonly={{this.isReadOnly}}
          @onUpdate={{this.setConnections}}
          @icon="ph:users-bold"
        />
        <small class="form-text text-muted">
          If the client requires single sign on then this will be set up by the
          digital team.<br />
          They will provide a connection name which can be added here.
        </small>
      </div>

      <div class="mb-3">
        <label class="form-label">Email Domains</label>
        <Tags
          @tags={{@client.domains}}
          @readonly={{this.isReadOnly}}
          @onUpdate={{this.setDomains}}
          @icon="ph:at-bold"
        />
        <div class="form-text">
          If a user signs up with an email address ending with one of these
          domains then they will be assigned to this client.
        </div>
      </div>
    </fieldset>
  </template>
}

export default UsersSection;
